// extracted by mini-css-extract-plugin
module.exports = {"investmentOptions":"InvestmentOptions-module--investmentOptions--2yuXg","cards":"InvestmentOptions-module--cards--agBMk"};